// RECEIVED NOTICE
export const LIST_RECEIVED_NOTICES = 'LIST_RECEIVED_NOTICES';
export const LIST_RECEIVED_NOTICES_SUCCESS = 'LIST_RECEIVED_NOTICES_SUCCESS';
export const LIST_RECEIVED_NOTICES_FAILED = 'LIST_RECEIVED_NOTICES_FAILED';
export const RECEIVE_NOTICE_SUCCESS = 'RECEIVE_NOTICE_SUCCESS';
export const UPDATE_RECEIVED_NOTICE_READ = 'UPDATE_RECEIVED_NOTICE_READ';
export const CLEAR_ALL_RECEIVED_NOTICES = 'CLEAR_ALL_RECEIVED_NOTICES';